import { createContext, useContext } from 'react';
import type { MyAccess } from '@/lib/api/types';

export interface AccessContextValue {
  /** The caller's resolved access (OPERATOR_ACCESS.md section 2). Never a
   *  loading state a screen has to branch on: `AccessProvider` starts and
   *  falls back at `FALLBACK_ACCESS`, so this is always a value to read. */
  access: MyAccess;
}

export const AccessContext = createContext<AccessContextValue | null>(null);

export function useMyAccess(): AccessContextValue {
  const context = useContext(AccessContext);
  if (!context) {
    throw new Error('useMyAccess must be used inside <AccessProvider>');
  }
  return context;
}
